import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import CustomInput from "../../component/custom-input";
import CustomButton from "../../component/Button";

function Setting() {
  return (
    <div>
      <Box sx={{ margin: "10px 0" }}>
        <Typography variant="h4" sx={{ fontSize: "30px", fontWeight: "500" }}>
          Setting
        </Typography>
      </Box>
      <Box className="FormBox" mb={3}>
        <Stack direction="row" spacing={2} width={600}>
          <lable>Firebase</lable>
          <input type="text" className="form-control" />
          <CustomButton
            variant="contained"
            sx={{
              background: "#327AFF",
              "&:hover": {
                backgroundColor: "#327AFF",
              },
            }}
          >
            Connect
          </CustomButton>
        </Stack>
      </Box>
      <Box className="FormBox">
        <Grid container spacing={2}>
          <Grid item lg={12}>
            <CustomInput label="Secret key" />
          </Grid>
          <Grid item lg={12}>
            <CustomInput label="Host Name" />
          </Grid>
          <Grid item lg={12}>
            <CustomInput label="SMTP Port Name" />
          </Grid>
          <Grid item lg={12}>
            <CustomInput label="SMTP User Name" />
          </Grid>
          <Grid item lg={12}>
            <CustomInput label="SMTP Password" />
          </Grid>
          <Grid item lg={12}>
            <CustomButton
              variant="contained"
              sx={{
                width: "165px",
                height: "50px",
                BorderRadius: "15px",
                background: "#327AFF",
                "&:hover": {
                  backgroundColor: "#327AFF",
                },
              }}
            >
              Submit
            </CustomButton>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default Setting;
